// extracted by mini-css-extract-plugin
export default {"scrollContainer":"styles_scrollContainer__70Gi7","infiniteScrollTable":"styles_infiniteScrollTable__-NktG","thead":"styles_thead__Lq4iV"};